import { render, staticRenderFns } from "./NewConfirmModal.vue?vue&type=template&id=b800b008"
import script from "./NewConfirmModal.vue?vue&type=script&lang=js"
export * from "./NewConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports